import React from 'react';
import CustomAlert from './CustomAlert';
import CustomConfirm from './CustomConfirm';
import { useCustomAlert, useCustomConfirm } from '../../hooks/useCustomAlert';

const WithCustomAlerts = ({ children }) => {
  const { alertState, showAlert, hideAlert, showSuccess, showError, showWarning, showInfo } = useCustomAlert();
  const { confirmState, showConfirm, hideConfirm } = useCustomConfirm();

  // Make alert functions available globally
  React.useEffect(() => {
    // Store the alert functions globally so they can be used by utility functions
    window._customAlert = {
      showAlert,
      showSuccess,
      showError,
      showWarning,
      showInfo,
      showConfirm,
      hideAlert,
      hideConfirm
    };

    // Replace global alert and confirm
    const originalAlert = window.alert;
    const originalConfirm = window.confirm;

    window.alert = (message) => {
      showAlert({ message, type: 'info', title: 'Alert' });
    };

    window.confirm = (message) => {
      return new Promise((resolve) => {
        showConfirm({
          message,
          onConfirm: () => {
            hideConfirm(); // Close the dialog first
            resolve(true); // Then resolve the promise
          },
          onCancel: () => {
            hideConfirm(); // Close the dialog first
            resolve(false); // Then resolve with false
          },
          title: 'Confirm Action',
          type: 'warning'
        });
      });
    };

    // Cleanup function
    return () => {
      window.alert = originalAlert;
      window.confirm = originalConfirm;
      delete window._customAlert;
    };
  }, [showAlert, showSuccess, showError, showWarning, showInfo, showConfirm]);

  return (
    <>
      {children}
      
      {/* Custom Alert and Confirm Components */}
      <CustomAlert
        isOpen={alertState.show}
        onClose={hideAlert}
        title={alertState.title}
        message={alertState.message}
        type={alertState.type}
        showCancel={alertState.showCancel}
        onConfirm={alertState.onConfirm}
        confirmText={alertState.confirmText}
        cancelText={alertState.cancelText}
      />

      <CustomConfirm
        isOpen={confirmState.isOpen}
        onCancel={confirmState.onCancel || hideConfirm}
        onConfirm={confirmState.onConfirm || hideConfirm}
        title={confirmState.title}
        message={confirmState.message}
        confirmText={confirmState.confirmText}
        cancelText={confirmState.cancelText}
      />
    </>
  );
};

export default WithCustomAlerts;

